import { z } from 'zod';
import { DecimalString, IsoDateTime, UuidString } from '../primitives.js';

/** UoM (глобальный справочник). */
export const UoM = z.object({
  id: UuidString,
  entity_id: UuidString,
  code: z.string().min(1),
  name: z.string().min(1),
  must_be_whole_number: z.boolean().default(false),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type UoM = z.infer<typeof UoM>;

/** UomConversion — per-item override между двумя UoM. */
export const UomConversion = z.object({
  id: UuidString,
  entity_id: UuidString,
  item_id: UuidString.nullable(), // null = global default
  from_uom: z.string().min(1),
  to_uom: z.string().min(1),
  factor: DecimalString,
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type UomConversion = z.infer<typeof UomConversion>;
